// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero__1OS-O","link":"link__2oetn","section":"section__2j6zk","c":"c__3qERd","subtitle":"subtitle__3tBEc","image":"image__37ier","buttons":"buttons__1SFV6"};